import LoadingIndicator from '../components/loading-indicator.vue';

export default {
  data: () => ({
    loading: 0,
  }),
  methods: {
    startRequest() {
      this.loading += 1;
    },
    finishRequest() {
      this.loading -= 1;
    },
    forceFinishRequest() {
      this.loading = 0;
    },
  },
  computed: {
    isLoading() {
      return this.loading > 0;
    },
  },
  components: {
    LoadingIndicator,
  },
};
